export default {
  methods: {
    bgImg (url) {
      return `background-image: url(${url})`
    },
    navigateTo (section) {
      if (this.$route.name !== 'Trabajo') {
        this.$store.commit('goToSection', section)
      } else {
        this.$router.push('/')
        this.$store.commit('goToSection', section)
      }
      if (this.$store.state.activeNavbar) {
        this.$store.commit('toggleNavbar')
      }
    }
  },
  filters: {
    vimeoId: function (val) {
      let id = val.split('/')
      console.log(id)
      return id[1]
    }
  }
}
